
'format es6';

import $ from 'jquery';
import gsap from 'greensock';
import Api from '../Api';
import ns from 'ns';

import { factory as sectionFactory } from './Section';
import { factory as questionFactory } from './ProfileQuestion';

require('../../views-compiled/quiz');

// Number of degrees of agreeness (disagree -> agree)
const ANSWER_RANGE = 3;
const EASING = gsap.Expo;
const MAX_QUESTIONS = 40;

function ProfileQuiz() {

	this.templateName = 'quiz.htm';

	let nQuestionsTotal;
	let currentQuestionIdx;
	let questionContainer;
	let currentIndexContainer;

	let questions;

	const answers = [];


	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 1, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 1, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	/**
	 * Loads the profile questions, then randomises the data while verifying
	 * that at least 2 questions per domain are served to the user. Puts it in
	 * the questions variable.
	 * 
	 * It then sets general templates values and the promise resolve with that object.
	 *
	 * @Promise {Object} tplValues
	 * @Reject {void} - Console logs the arguments.  
	 * 
	 * @return {Promise}
	 */
	this.init = () => {
		return Api.request(`profile-questions/${ns.lang}`).then(res => {
			questions = res;
			currentQuestionIdx = 0;

			// Verify that we have at least 2 questions of each domain
			const domains = [];
			const filteredQuestions = [];
			if (questions.length > MAX_QUESTIONS) {
				questions.forEach((q) => {
					if (domains.indexOf(q.domaine_id) === -1) {
						domains.push(q.domaine_id);
					}
				});

				domains.forEach((d) => {
					while (filteredQuestions.filter(q => q.domaine_id === d).length < 2) {
						const questionsPerDomain = questions.filter(q => q.domaine_id === d);
						let randIndex = Math.floor(Math.random() * (questionsPerDomain.length - 1));
						let newQ = questionsPerDomain[randIndex];

						while (filteredQuestions.indexOf(newQ) > -1) {
							randIndex = Math.floor(Math.random() * (questionsPerDomain.length - 1));
							newQ = questionsPerDomain[randIndex];
						}

						filteredQuestions.push(newQ);
					}
				});


				while (filteredQuestions.length < MAX_QUESTIONS) {
					let randIndex = Math.floor(Math.random() * (questions.length - 1));
					let newQ = questions[randIndex];

					while (filteredQuestions.indexOf(newQ) > -1) {
						randIndex = Math.floor(Math.random() * (questions.length - 1));
						newQ = questions[randIndex];
					}

					filteredQuestions.push(newQ);
				}

				questions = filteredQuestions;
			}

			// Set questions in random order
			questions = ns.shuffleArray(questions);
			nQuestionsTotal = questions.length;

			const tplValues = {
				currentQuestion: 0,
				nQuestionsTotal,
			};

			return tplValues;
		}).catch((res) => {
			console.log(arguments);
		});
	};

	const computeResults = () => {

		const answersByDomain = questions.reduce((allDoms, question, qIdx) => {
			const answer = answers[qIdx];
			const domainId = question.domaine_id;
			const domainAnswers = allDoms[domainId] = allDoms[domainId] || [];
			domainAnswers.push(answer);
			return allDoms;
		}, {});

		const domains = Object.keys(answersByDomain).map((domainId) => {
			const domainAnswers = answersByDomain[domainId];
			
			// Sum all the answers for this domain
			const points = domainAnswers.reduce((sum, val) => sum + val);

			// points / maximum points possible
			//const ratio = points / (domainAnswers.length * ANSWER_RANGE);
			// jo: correct points (1..4) to (0..3) by substracting 1 per answer!
			const ratio = (points - domainAnswers.length) / (domainAnswers.length * ANSWER_RANGE);

			return {
				id: domainId,
				points,
				ratio,
			};
		});

		// Animate out of the quiz and go to showProfileResult() (Main.js)
		this.animateOut().then(() => {
			this.next && this.next(domains,questions);
			this.next = null;
		});
	};

	function nextQuestion(answer) {
		answers[currentQuestionIdx] = answer;
		questions[currentQuestionIdx].score = answer; // JO: questions stats!

		currentQuestionIdx++;

		if (currentQuestionIdx < nQuestionsTotal) return addQuestion();

		// Else, compute the results
		computeResults();
	}

	function prevQuestion() {
		currentQuestionIdx--;

		// If we have a prev question, add it!
		if (currentQuestionIdx < nQuestionsTotal) return addQuestion();

		// Else, compute the results
		computeResults();
	}


	function addQuestion() {
		const questionView = questionFactory();
		currentIndexContainer.html(currentQuestionIdx + 1);

		// Extend the question object to have the currentQuestionIdx and
		// the total number of questions
		questionView.setData(Object.assign({
			currentQuestion: currentQuestionIdx + 1,
			nQuestionsTotal,
		}, questions[currentQuestionIdx]));

		const onReady = questionView.render(questionContainer);
		onReady.then(() => {
			questionView.onNext(nextQuestion);
			questionView.onPrev(prevQuestion);
			questionView.animateIn();
		});
	}

	this.activate = () => {
		questionContainer = $('[data-question]', this.sectionNode);
		currentIndexContainer = $('[data-current]', this.sectionNode);

		addQuestion();
	};

	this.deactivate = () => {

	};

	return this;
}


export function factory(instance) {
	return ProfileQuiz.call(sectionFactory(instance || {}));
}
